import axios from 'axios'
import { CommonStatusResponse, SubportionAnalysisStatusResponse } from '@/api/services/common/status/common-status.dto'

class CommonStatusService {
    /**
     * find all states of assays
     */
    async getAssayStates(): Promise<CommonStatusResponse[]> {
        const response = await axios.get<CommonStatusResponse[]>(`/common/assays/states`)
        return response.data
    }

    /**
     * find all states of cases except DELETED
     */
    async getCaseStates(): Promise<CommonStatusResponse[]> {
        const response = await axios.get<CommonStatusResponse[]>(`/common/cases/states`)
        return response.data
    }

    /**
     * find all states of portions
     */
    async getPortionStates(): Promise<CommonStatusResponse[]> {
        const response = await axios.get<CommonStatusResponse[]>(`/common/portions/states`)
        return response.data
    }

    /**
     * find all states of requests except DELETED
     */
    async getRequestStates(): Promise<CommonStatusResponse[]> {
        const response = await axios.get<CommonStatusResponse[]>(`/common/requests/states`)
        return response.data
    }

    /**
     * find all states of samples except DELETED
     */
    async getSampleStates(): Promise<CommonStatusResponse[]> {
        const response = await axios.get<CommonStatusResponse[]>(`/common/samples/states`)
        return response.data
    }

    /**
     * find all states of subportions
     */
    async getSubportionStates(): Promise<CommonStatusResponse[]> {
        const response = await axios.get<CommonStatusResponse[]>(`/common/subportions/states`)
        return response.data
    }

    async getAiAnalysisStates(): Promise<SubportionAnalysisStatusResponse[]> {
        const response = await axios.get<SubportionAnalysisStatusResponse[]>(`common/subportionAnalysisStatus`)
        return response.data
    }
}

export const commonStatusService = new CommonStatusService()
